import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      marginBottom: 20,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    modalContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      maxWidth: '365px',
      borderRadius: 8,
      backgroundColor: theme.oysterTheme.cotton,
      outline: 'none',
      padding: theme.spacing(3),
      fontSize: 14,

      '& h3': {
        textAlign: 'center',
        color: theme.oysterTheme.pine,
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 24,
      },
      '& p': {
        lineHeight: '20px',
      },
    },
    memo: {
      display: 'flex',
      justifyContent: 'space-between',
      background: 'red',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
      backgroundColor: theme.oysterTheme.pearl,
      borderRadius: 8,
    },
    pin: {
      '& .pincode-input-container': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        display: 'flex',
        justifyContent: 'center',
        outline: 'none',
      },
      '& .pincode-input-text': {
        border: '0 !important',
        borderRadius: '4px !important',
        background: `${theme.oysterTheme.pearl} !important`,
        color: '#000000 !important',
        width: '50px !important',
        height: '65px !important',
        fontSize: '16px !important',
        fontWeight: '600 !important',
        [`&:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active`]: {
          '-webkit-box-shadow': `0 0 0px 1000px ${theme.oysterTheme.pearl} inset !important`,
          color: '#000000 !important',
        },
      },
    },
    verifyButton: {
      display: 'block',
      margin: '0 auto',
    },
    loader: {
      zIndex: 1,
      position: 'absolute',
      width: '100%',
      background: 'white',
      height: '100%',
    },
    modalContent: {
      position: 'relative',
    },
    hide: {
      display: 'none',
    },
    invisible: {
      visibility: 'hidden',
    },
    closeButton: {
      position: 'absolute',
      right: 15,
      top: 10,
    },
  });
};

export default makeStyles(styles);
